import {Injectable, TemplateRef} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ComponentType} from '@angular/cdk/portal';
import {InfoDialogComponent} from './info-dialog.component';

@Injectable({providedIn: 'root'})
export class InfoDialogService {

  get isMobile(): boolean {
    return window.innerWidth < 1199;
  }

  constructor(private dialog: MatDialog) {
  }

  show<T>(component: ComponentType<T> | TemplateRef<T> | string) {
    this.internalShow(InfoDialogComponent, component);
  }

  private internalShow<T>(component: ComponentType<T> | TemplateRef<T> | string, data?: any) {
    this.dialog.open(InfoDialogComponent, {
      data,
      width: this.isMobile ? '90vw' : '720px',
      maxWidth: '90vw',
      panelClass: ['dialog-container', 'info-panel'],
      backdropClass: 'info-backdrop'
    });
  }
}
